import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChecklist2GeneralSectionEditComponent } from './general-section-edit.component';
import { FiTwoColumnsContainerModule } from '../../../fi-two-columns-container/fi-two-columns-container.module';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { FiIconTooltipButtonModule } from '../../../fi-icon-tooltip-button/fi-icon-tooltip-button.module';
import { FiAppTextSharedModule } from '../../../app-text';
import { FiSectionCardModule } from '../../../fi-section-card/fi-section-card.module';
import { FiChecklist2TranslationModule } from '../../fi-checklist2-translation/fi-checklist2-translation.module';
import { MatButtonModule } from '@angular/material/button';
import { FiChecklist2CommonDataComponent } from '@fi-shared/checklist/fi-checklist2-edit/general-section-edit/common-data/common-data.component';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { MatListModule } from '@angular/material/list';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { FiObjectEditorInfoModule } from '@fi-shared/fi-object-editor-info/fi-object-editor-info.module';
import { FiCheckbox2Module } from '@fi-shared/fi-checkbox2/fi-checkbox2.module';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiAccessRightFiltersModule } from '@fi-shared/access-right-filters';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FiChecklist2QRCodesDialogComponent } from './qr-codes-dialog/qr-codes-dialog.component';
import { FiToggleSwitchModule } from '@fi-shared/fi-toggle-switch/fi-toggle-switch.module';
import { FiQRCodeViewModule } from '@fi-shared/fi-qr-code-view/qr-code-view.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { FiTextPanelModule } from '@fi-shared/fi-text-panel/fi-text-panel.module';
import { FiContenteditableModelModule } from '@fi-shared/contenteditable-model/contenteditable-model.module';
import { FiContenteditableModule } from '@fi-shared/fi-contenteditable/fi-contenteditable.module';
import { FiComplianceThresholdDialogComponent } from '@fi-shared/checklist/fi-checklist2-edit/general-section-edit/compliance-threshold-dialog/compliance-threshold-dialog.component';
import { MatOption } from '@angular/material/autocomplete';
import { MatSelect } from '@angular/material/select';
import { FiChecklist2ScheduleDescriptionModule } from '@fi-shared/checklist/fi-checklist2-schedule-description/fi-checklist2-schedule-description.module';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { FiThreeColumnsContainerModule } from '@fi-shared/fi-three-columns-container/fi-three-columns-container.module';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { FiChecklist2TemplateDescriptionModule } from '@fi-shared/checklist/fi-checklist2-template-description/fi-checklist2-template-description.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { ChecklistAiAssistanceModule } from '@fi-shared/checklist/fi-checklist2-edit/checklist-ai-assistance/checklist-ai-assistance.module';
import { FiManualSharingSelectionInfoContainerModule } from '@fi-shared/fi-manual-sharing-selection-info-container/fi-manual-sharing-selection-info-container.module';
import { FiSimpleContenteditableModule } from '@fi-shared/fi-simple-contenteditable/fi-simple-contenteditable.module';
import { FiTooltipModule } from '@fi-shared/fi-tooltip/fi-tooltip.module';
import { FiAutomatedActionListItemModule } from '@fi-shared/automated-action-list-item/action-list-item.module';
import { FiNameDescriptionInputModule } from '@fi-shared/name-description-input/name-description-input.module';

@NgModule({
    imports: [
        CommonModule,
        FiTwoColumnsContainerModule,
        MatCardModule,
        MatIconModule,
        FiIconTooltipButtonModule,
        FiAppTextSharedModule,
        FiSectionCardModule,
        FiChecklist2TranslationModule,
        MatButtonModule,
        MatInputModule,
        FormsModule,
        InfoIconModule,
        MatListModule,
        FiAttachmentsModule,
        FiObjectEditorInfoModule,
        FiCheckbox2Module,
        FiProfileIconModule,
        FiAccessRightFiltersModule,
        FiLoadingModule,
        FiToggleSwitchModule,
        FiQRCodeViewModule,
        FiWrapperTableModule,
        FiFormatDateModule,
        FiTextPanelModule,
        FiContenteditableModelModule,
        FiContenteditableModule,
        FiAutomatedActionListItemModule,
        MatOption,
        MatSelect,
        FiChecklist2ScheduleDescriptionModule,
        MatRadioButton,
        MatRadioGroup,
        FiThreeColumnsContainerModule,
        FiValidatingFormModule,
        FiChecklist2TemplateDescriptionModule,
        ChecklistAiAssistanceModule,
        MatCheckboxModule,
        SelectSearchModule,
        FiManualSharingSelectionInfoContainerModule,
        FiSimpleContenteditableModule,
        FiTooltipModule,
        FiNameDescriptionInputModule,
    ],
    declarations: [
        FiChecklist2GeneralSectionEditComponent,
        FiChecklist2CommonDataComponent,
        FiComplianceThresholdDialogComponent,
        FiChecklist2QRCodesDialogComponent,
    ],
    exports: [FiChecklist2GeneralSectionEditComponent, FiChecklist2CommonDataComponent],
})
export class FiChecklist2GeneralSectionEditModule {}
